import {Button, Modal, Spinner} from "react-bootstrap";
import React, {useEffect, useState} from 'react';

export default function AddWaterSystemModal(props) {
    const [isAddButtonClicked, setIsAddButtonClicked] = useState(false);
    const [waterSystemDetails, setWaterSystemDetails] = useState(null);
    const [isRequestInProgress, setIsRequestInProgress] = useState(false);
    const [isCancelButtonClicked, setIsCancelButtonClicked] = useState(false);

    const handleAdd = () => {
        setIsAddButtonClicked(true);
    }

    const handleCancel = () => {
        props.setShow(false);
        setTimeout(() => {
            setIsCancelButtonClicked(true);
            setWaterSystemDetails(null);
            setIsAddButtonClicked(false);
        }, 500)
    }

    const renderModalBody = () => {
        if (isAddButtonClicked && waterSystemDetails) {
            return (
                <>
                    <div>Hardware ID: {waterSystemDetails.hardwareId}</div>
                    <div>Device ID: {waterSystemDetails.controlUnitId}</div>
                </>
            )
        } else {
            return (<div>Are you sure you want to add a new water system?</div>)
        }
    }

    const renderTitle = () => {
        if (isAddButtonClicked && waterSystemDetails) {
            return (<div> Water System Details</div>);
        } else {
            return (<div>Add Water System</div>);
        }
    }

    const renderButtons = () => {
        if (isAddButtonClicked && waterSystemDetails) {
            return (<Button style={{width: 80}} onClick={() => handleCancel()} variant="primary">Close</Button>);
        } else {
            if (isRequestInProgress) {
                return (
                    <>
                        <Button disabled variant="primary"><Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            className='mr-1'
                        />
                            Adding...</Button>
                        <Button style={{width: 80}} onClick={() => handleCancel()} variant="primary">Cancel</Button>
                    </>
                )
            } else {
                return (
                    <>
                        <Button disabled={isRequestInProgress} style={{width: 80}} onClick={() => handleAdd()} variant="primary">Add</Button>
                        <Button style={{width: 80}} onClick={() => handleCancel()} variant="primary">Cancel</Button>
                    </>
                )
            }
        }
    }

    const addWaterSystem = async () => {
        setIsRequestInProgress(true);
        const response = await props.controlUnitService.addWaterSystem(props.controlUnitId);
        setIsRequestInProgress(false);
        if (!response) {
            console.error(`Data from add water system is empty`);
            return;
        }
        setWaterSystemDetails(response.data);
    }

    useEffect(() => {
        if (isAddButtonClicked) {
            addWaterSystem();
        }
    }, [isAddButtonClicked])

    useEffect(() => {
        if (isCancelButtonClicked) {
            setWaterSystemDetails(null);
        }
        setIsCancelButtonClicked(false);
    }, [waterSystemDetails])


    return (
        <Modal dialogClassName="filter-modal" show={props.show} onHide={() => {
            props.setShow(false)
            handleCancel();
        }} style={{marginTop: '10%', left: '1%'}}>
            <Modal.Header closeButton>
                <Modal.Title>{renderTitle()}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {renderModalBody()}
            </Modal.Body>
            <Modal.Footer>
                {renderButtons()}
            </Modal.Footer>
        </Modal>
    )
}


